var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke-linecap:round;stroke-width:3px;}")),React.createElement("g",{"transform":"translate(-1136.945 -1237.058)","key":1},React.createElement("g",{"transform":"translate(23.234 9)"},[React.createElement("path",{"className":"a","d":"M2705.374,1230.179l7.386,7.386-7.386,7.386","transform":"translate(-1573.548 0)","key":0}),React.createElement("path",{"className":"a","d":"M2720.212,1234.252h-24","transform":"translate(-1581 3.313)","key":1})]))]);
}

ArrowRight.defaultProps = {"width":"27.623","height":"19.015","viewBox":"0 0 27.623 19.015"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
